<template>

<div v-html="text"/>

</template>

<script>
export default {
  name: 'Title',
  props: {
    text: String
  }
}
</script>

<style lang="scss" scoped>
div {
  font-size: 40px;
  text-align: left;
  font-family: 'Poppins-ExtraBold';
  font-weight: bold;
  text-transform: uppercase;
}
</style>
